// extracted by mini-css-extract-plugin
export var hideEditor = "_mi-2";
export var infoIcon = "_mi-3";
export var label = "_mi-1";
export var labelContainer = "_mi-0";
export var readonlyText = "_mi-4";